import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    label: 'PSYCHOTHERAPIST CLIENT INTAKE FORM',
    subLabel: '',
    field: 'psychoQuestions',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label:
            'Please list any current or past mental health conditions that you have struggled with: ',
          type: 'text',
          name: 'currentOrPastMentalHealthConditions',
          rows: 2
        },
        {
          label: 'Have you been to counselling before?',
          type: 'single_select',
          field: 'counselling',
          level: 'child',
          options: [
            { key: 'counsellingYes', value: 'Yes' },
            { key: 'counsellingNo', value: 'No' }
          ]
        },
        {
          label:
            'Have you experienced any previous or recent trauma? If so, please select all that apply.',
          type: 'multi_select',
          field: 'trauma',
          level: 'child',
          options: [
            { key: 'divorce', value: 'Divorce' },
            { key: 'separation', value: 'Separation' },
            { key: 'sexualAbuse', value: 'Sexual Abuse' },
            { key: 'hateCrime', value: 'Hate Crime' },
            { key: 'deaths', value: 'Deaths' },
            { key: 'abusiveRelationship', value: 'Abusive Relationship' },
            { key: 'physicalTorture', value: 'Physical Torture' },
            { key: 'stalking', value: 'Stalking' },
            { key: 'physicalAbuse', value: 'Physical Abuse' },
            {
              key: 'otherExplain',
              value: 'Other (please explain)',
              answer: {
                type: 'text',
                name: 'otherExplainText',
                rows: 1
              }
            }
          ]
        },
        {
          label: 'Are you struggling with any of the following?',
          type: 'multi_select',
          field: 'struggles',
          level: 'child',
          options: [
            { key: 'anxiety', value: 'Anxiety' },
            { key: 'depression', value: 'Depression' },
            { key: 'obsessiveThinking', value: 'Obsessive Thinking' },
            {
              key: 'obsessiveBehaviour',
              value: 'Obsessive Behaviour (excessive hand washing, etc.)'
            },
            { key: 'suicidalThoughts', value: 'Suicidal Thoughts' },
            { key: 'suicidalAttempts', value: 'Suicidal Attempts' },
            { key: 'homicidalThoughts', value: 'Homicidal Thoughts' },
            { key: 'panicAttacks', value: 'Panic Attacks' },
            { key: 'selfHarm', value: 'Self-Harm' }
          ]
        },
        {
          label: 'Who are your biggest supporters?',
          type: 'multi_select',
          field: 'biggestSuupporters',
          level: 'child',
          options: [
            { key: 'friends', value: 'Friends' },
            { key: 'family', value: 'Family' },
            { key: 'coworkers', value: 'Co-workers' },
            { key: 'neighbours', value: 'Neighbours' },
            { key: 'animals', value: 'Animals' },
            {
              key: 'none',
              value: 'None',
              uncheckOthers: true
            }
          ]
        },
        {
          label:
            'Goals for counseling – What is the desired change wished for as a result of counseling?',
          type: 'text',
          name: 'goalsForCounseling',
          rows: 2
        }
      ]
    }
  }
];

export default questionsModels;
